import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, V2ShareMessengerIcon } from '@paypalcorp/pp-react';

function SocialShareMessenger({ url, handleSocialLinkClick, linkTitle }) {
  return (
    <IconButton
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'messenger')}
      data-testid="social-share-messenger"
      size="sm"
      buttonType="secondary"
      svgIconComponent={V2ShareMessengerIcon}
    >
      {linkTitle}
    </IconButton>
  );
}

SocialShareMessenger.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.string,
};

export default SocialShareMessenger;
